export enum SetupErrorCodeEnum {
  PAYCARD_NOT_FOUND = 'PAYCARD_NOT_FOUND',
  CARD_NOT_INIT = 'CARD_NOT_INIT',
  MERCHANT_NOT_FOUND_AT_PROFIPAY = 'MERCHANT_NOT_FOUND_AT_PROFIPAY',
  USE_EMAIL_FOR_LOGIN = 'USE_EMAIL_FOR_LOGIN'
}
